import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { SIZES, GAPS } from './constants';
import PaymentMethod from './components/payment-method';

const defaultTypes = [];

const PaymentMethods = ({
  centered = false,
  size = SIZES.large,
  types = defaultTypes,
  gap = GAPS['spacing-3-xs'],
}) => {
  const classes = classnames(
    'ws-ui-payment-methods',
    `ws-ui-payment-methods--${size}`,
    `ws-ui-payment-methods--${gap}`,
    {
      'ws-ui-payment-methods--mobile-centered': centered,
    }
  );

  return (
    <div className={classes}>
      {types.map((type) => (
        <PaymentMethod key={type} type={type} size={size} />
      ))}
    </div>
  );
};

PaymentMethods.propTypes = {
  centered: PropTypes.bool,
  size: PropTypes.oneOf(Object.values(SIZES)),
  gap: PropTypes.oneOf(Object.values(GAPS)),
  types: PropTypes.arrayOf(PropTypes.string),
};

export { PaymentMethods, PaymentMethod };
